import { render, staticRenderFns } from "./KkArticleInfo.vue?vue&type=template&id=6107e878&scoped=true"
import script from "./KkArticleInfo.vue?vue&type=script&lang=js"
export * from "./KkArticleInfo.vue?vue&type=script&lang=js"
import style0 from "./KkArticleInfo.vue?vue&type=style&index=0&id=6107e878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107e878",
  null
  
)

export default component.exports